import React from "react";
import type { Direction } from "@/components/layout/Flex";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import { directionPaddingMap } from "../consts";
import { type CardProps, cardVariants } from "../types";

function Card({
  id,
  variant = "default",
  direction = "column",
  className,
  ...props
}: CardProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex
      data-slot="card"
      id={`CARD${id ? `-${id}` : ""}`}
      direction={direction}
      justify="start"
      items="center"
      className={cn(
        directionPaddingMap[direction as Direction],
        cardVariants({ className, variant }),
        classes,
      )}
      {...native}
    />
  );
}

Card.displayName = "Card";

export default Card;
